import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import legalAssociationsTerroristOrganizationMemebershipItemValidator from './validators/item';
import { LegalAssociationsTerroristOrganizationMembershipModel } from './types';

const legalAssociationsTerroristOrganizationMembershipValidator: ValidateJSModel<LegalAssociationsTerroristOrganizationMembershipModel> = {
  HasTerroristOrganizationMembership: { hasValue: { validator: hasYesOrNo } },

  List: (value, attributes) => {
    if (attributes?.HasTerroristOrganizationMembership && attributes?.HasTerroristOrganizationMembership?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: legalAssociationsTerroristOrganizationMemebershipItemValidator },
      };
    }
    return {};
  },
};

export default legalAssociationsTerroristOrganizationMembershipValidator;
